var helpers = require('./helpers');

var validate = function validate(name, testName) {
  return function (value) {
    if (!helpers[testName](value)) throw new Error("invalid ".concat(name, ": ").concat(value));
  };
};

module.exports = {
  entityId: validate('entity id', 'isEntityId'),
  propertyId: validate('property id', 'isPropertyId'),
  entityPageTitle: validate('entity page title', 'isEntityPageTitle'),
  revisionId: validate('revision id', 'isRevisionId')
};